module.exports = __webpack_public_path__ + "img/Katete-Nathan.883378fa.jpg";